import * as React from 'react';

function Warning(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={26} height={24} viewBox="0 0 26 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.023 22.5l12.944-21 12.944 21H.023zm24.172-.933L12.967 3.38 1.74 21.567h22.457zM13.714 9.433H12.22l.25 6.534h.995l.249-6.534zm-.747 9.796c-.55 0-.995-.418-.995-.933 0-.515.445-.934.995-.934s.996.419.996.934c0 .515-.446.933-.996.933z"
        fill="#F7BB56"
      />
    </svg>
  );
}

export default Warning;
